interface GiftsBackgroundSvgProps {
  className?: string;
}

export const GiftsBackgroundSvg = ({ className }: GiftsBackgroundSvgProps) => {
  return (
    <svg
      width="535"
      height="179"
      viewBox="0 0 535 179"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g opacity="0.3">
        <g opacity="0.5" filter="url(#filter0_d_7796_6048)">
          <rect
            x="11.9678"
            y="71.6451"
            width="117.753"
            height="164.102"
            fill="#D9B7AC"
          />
        </g>
        <rect
          x="63.3281"
          y="71.6451"
          width="15.0323"
          height="131.532"
          fill="#D9B7AC"
        />
        <g opacity="0.5" filter="url(#filter1_d_7796_6048)">
          <rect
            x="4.45166"
            y="40.3279"
            width="132.785"
            height="33.8226"
            rx="3"
            fill="#D9B7AC"
          />
        </g>
        <g opacity="0.5" filter="url(#filter2_d_7796_6048)">
          <rect
            x="295.075"
            y="4"
            width="235.505"
            height="221.726"
            rx="9"
            fill="#D9B7AC"
          />
        </g>
        <rect x="400.301" y="4" width="25.0538" height="233" fill="#FFFAF8" />
        <rect
          x="530.581"
          y="90.4355"
          width="25.0538"
          height="235.505"
          transform="rotate(90 530.581 90.4355)"
          fill="#FFFAF8"
        />
        <path
          d="M481.617 73.5989C483.484 73.1981 485.246 74.6219 485.246 76.5322L485.246 134.248C485.246 136.158 483.484 137.582 481.617 137.181L408.697 121.534C407.315 121.237 406.327 120.015 406.327 118.601L406.327 92.1791C406.327 90.7648 407.315 89.5426 408.697 89.2459L481.617 73.5989Z"
          fill="#F4E9E5"
        />
        <path
          d="M343.573 137.166C341.703 137.574 339.934 136.15 339.934 134.235L339.934 76.5448C339.934 74.6304 341.703 73.2058 343.573 73.6136L415.24 89.2398C416.618 89.5403 417.601 90.7604 417.601 92.171L417.601 118.609C417.601 120.02 416.618 121.24 415.24 121.54L343.573 137.166Z"
          fill="#F4E9E5"
        />
        <g filter="url(#filter3_d_7796_6048)">
          <rect
            x="148.51"
            y="65.3818"
            width="162.849"
            height="145.312"
            rx="9"
            fill="#D9B7AC"
          />
        </g>
        <rect
          x="221.167"
          y="56.7151"
          width="17.5376"
          height="154.081"
          fill="#F4E9E5"
        />
        <path
          d="M270.927 46.1175C272.795 45.7167 274.556 47.1405 274.556 49.0507L274.556 81.5574C274.556 83.4677 272.795 84.8914 270.927 84.4906L228.548 75.3973C227.165 75.1005 226.177 73.8783 226.177 72.464L226.177 58.1441C226.177 56.7298 227.165 55.5076 228.548 55.2109L270.927 46.1175Z"
          fill="#F4E9E5"
        />
        <path
          d="M188.468 84.4906C186.6 84.8914 184.838 83.4676 184.838 81.5573L184.838 49.0507C184.838 47.1404 186.6 45.7167 188.468 46.1175L230.847 55.2108C232.23 55.5076 233.217 56.7298 233.217 58.1441L233.217 72.464C233.217 73.8783 232.23 75.1005 230.847 75.3972L188.468 84.4906Z"
          fill="#F4E9E5"
        />
        <rect
          x="311.36"
          y="129.269"
          width="17.5376"
          height="162.849"
          transform="rotate(90 311.36 129.269)"
          fill="#F4E9E5"
        />
        <path
          d="M70.8438 45.3387L70.8438 30.3065L43.6407 19.4252C41.6701 18.637 39.5265 20.0883 39.5265 22.2107L39.5265 53.4345C39.5265 55.5569 41.6701 57.0082 43.6407 56.2199L70.8438 45.3387Z"
          fill="#D9B7AC"
        />
        <path
          d="M70.8437 30.3065L70.8437 45.3387L98.0468 56.22C100.017 57.0082 102.161 55.5569 102.161 53.4345L102.161 22.2107C102.161 20.0883 100.017 18.637 98.0468 19.4253L70.8437 30.3065Z"
          fill="#D9B7AC"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_7796_6048"
          x="7.96777"
          y="67.6451"
          width="125.753"
          height="172.102"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7796_6048"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7796_6048"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_7796_6048"
          x="0.45166"
          y="36.3279"
          width="140.785"
          height="41.8226"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7796_6048"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7796_6048"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_7796_6048"
          x="291.075"
          y="0"
          width="243.505"
          height="229.726"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7796_6048"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7796_6048"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_7796_6048"
          x="144.51"
          y="61.3818"
          width="170.85"
          height="153.312"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7796_6048"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7796_6048"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
